import { createApp } from 'vue'
import App from './App.vue'

import './styles/portfolio.scss';
import './styles/email.scss';
import './styles/bouncingIcons.scss';
import './styles/marquee.scss';
import './styles/eyes.scss';
import './styles/home.scss';
import './styles/blobButton.scss';
import './styles/_utilities.scss';



createApp(App).mount('#app')
